/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Draftemail_Access_Title2Inputs */

const en_coinvestments_draftemail_access_title2 = /** @type {(inputs: Coinvestments_Draftemail_Access_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access — applied when this email sends`)
};

/**
* | output |
* | --- |
* | "Access — applied when this email sends" |
*
* @param {Coinvestments_Draftemail_Access_Title2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_access_title2 = /** @type {((inputs?: Coinvestments_Draftemail_Access_Title2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Access_Title2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_access_title2(inputs)
});
export { coinvestments_draftemail_access_title2 as "coInvestments_draftEmail_access_title" }